export default __webpack_public_path__ + "media/zurb/img/bryan/thumbs/4-05aa27b802141fbb1f490d7cd11f1ae2.png";